import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import StartInterviewCard from "./StartInterviewCard";
import UpcomingInterviews from "./UpcomingInterviews";
import RecentPerformance from "./RecentPerformance";
import StatsCards from "../../Card/StatsCard";
import { getStudentInterviewMetrics } from "../../../application/services/studentDashboard";

const StudentDashboard = () => {
  const { user } = useSelector((state) => state.login.student);
  const email = user?.email || "";
  const [studentMetrics, setStudentMetrics] = useState(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!email || hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    getStudentInterviewMetrics(email)
      .then((data) => setStudentMetrics(data))
      .catch((err) => console.error("Error fetching student metrics:", err));
  }, [email]);

  return (
    <>
      <StartInterviewCard />
      <StatsCards metrics={studentMetrics} variant="student" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <UpcomingInterviews />
        <RecentPerformance />
      </div>
    </>
  );
};

export default StudentDashboard;
